import ProductPurchase from '@components/ProductPurchase'
import styles from '@styles/ProductPage.module.css'
import UseWhatsapp from 'whatsapp-react-component'
import useFormatPrice from '@hooks/useFormatPrice'
import SocialLinks from '@components/SocialLinks'
import TermsModal from '@components/TermsModal'
import { useParams } from 'react-router-dom'
import useProduct from '@hooks/useProduct'
import Navbar from '@components/Navbar'
import { useState } from 'react'

const ProductPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const formatPrice = useFormatPrice()
  const { id } = useParams()
  const { product } = useProduct(id)

  if (!id) {
    return <div className={styles.loading}>Cargando...</div>
  }

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const handleAcceptTerms = () => {
    const whatsappNumber = '573223110646'
    const greeting = '¡Hola! Gracias por tu interés en nuestros productos. A continuación, te detallo tu pedido:\n\n'
    const message =
      `📦 *Producto:* ${product.brand}\n` +
      `📝 *Referencia:* ${product.reference}\n` +
      `🔢 *Cantidad:* 1\n` +
      `💰 *Precio unitario:* ${formatPrice(product.price)}\n` +
      `*Subtotal:* ${formatPrice(product.price)}`
    const totalMessage = `\n\n💳 *Total del pedido:* ${formatPrice(product.price)}`
    const footer = '\n\n¿Te gustaría proceder con tu compra? Estaremos encantados de atenderte. 😊'
    const fullMessage = `${greeting}${message}${totalMessage}${footer}`
    UseWhatsapp(whatsappNumber, fullMessage)
    closeModal()
  }

  return (
    <div className={styles.productPage}>
      <Navbar className={styles.productNavbar} />
      <main className={styles.mainContent}>
        <ProductPurchase id={id} onWhatsAppPurchase={openModal} />
      </main>
      <footer className={styles.footer}>
        <div className={styles.footerContainer}>
          <SocialLinks />
        </div>
      </footer>
      <TermsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onAccept={handleAcceptTerms}
        productTitle={product ? `${product.brand} ${product.reference}` : 'Producto'}
      />
    </div>
  )
}

export default ProductPage

